var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('MetaLogo',{attrs:{"meta-data":_vm.metaData,"name":_vm.name}})
}
var staticRenderFns = []

export { render, staticRenderFns }